<template>
  <div>
    <embed-api-table
      title="Keyword Search Result Screenshots"
      module="Search-Results"
      v-bind:refresh-for-id="refreshId"
      default-sort="createdAt DESC"
      @click="resultClicked"
      v-bind:columns="screenshotColumns"
      v-bind:fields="screenshotFields"
      v-bind:filter="screenshotFilter">
    </embed-api-table>
  </div>
</template>

<script>
  import EmbedApiTable from "./EmbedApiTable.vue";
  import WebLLCRESTApi from "../api/api";
  import { countries } from "../util/geotargets.js";
  import $ from "jquery";
  
  export default {
    created() {
      // prepare api
      this.api = new WebLLCRESTApi("Search-Results", this.$router);
    },
    
    props: {
      clientId: String
    },
    
    data() {
      return {
        screenshotColumns: this.getColumns(),
        
        screenshotFields: { linkData: false },
        screenshotFilter: { clientId: this.clientId, page: 1, captureType: "MangoolsV3" },
        
        refreshId: Date.now().toString(),
      };
    },
    
    methods: {
      async resultClicked(data) {
        if(data.item) {
          const result = data.item.item;
          
          if(data.col.text == "Add Missing Links") {
            this.$router.push("/addmissinglinks/" + result.id);
          }
        }
      },
      
      getColumns() {
        const cols = [
          { key: "keyword", "text": "Keyword", type: "String", sort: true },
          { key: "searchType", "text": "Search Type", type: "String", sort: true },
          { key: "locationId", "text": "Location", type: "String", sort: false, fnAsyncLoad: this.resolveLocationId },
          { key: "createdAt", "text": "Search Date", type: "DateTime", sort: true },
          { key: "missing", "text": "Add Missing Links", type: "Event", sort: false },
        ];
        
        return cols;
      },
      
      resolveLocationId(item) {
        for(const country of countries) {
          if(country.id == item.locationId) {
            return country.code;
          }
          
          for(const state of country.states) {
            if(state.id == item.locationId) {
              return state.state;
            }
            
            for(const city of state.cities) {
              if(city.id == item.locationId) {
                return city.city;
              }
            }
          }
        }
        
        return "Unknown (" + item.locationId + ")";
      }
    },

    components: {
      EmbedApiTable,
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/MissingLinkTable.vue